import { connect } from 'react-redux';
import { selectors as userSelectors } from 'dux/user';
import { actionCreators } from '../../dux/instances';
import AclList from './AclList';

const mapStateToProps = (state) => ({
  userRoles: userSelectors.getIdentityState(state).roles,
});

const mapDispatchToProps = {
  deleteInstanceAcl: actionCreators.deleteInstanceAcl,
};

export default connect(mapStateToProps, mapDispatchToProps)(AclList);
